import React from 'react';
import Brand1 from "../../assets/img/brand/logoHLF1.png";
import Brand2 from "../../assets/img/brand/logoHLF2.png";

function Brand() {
  return (
    <div className="brand-area pt-30 pb-30" style={{ background: "#f7f5f1" }}>
      <div className="container">
        <div className="row justify-content-center" style={{ gap: "30px" }}>
          <div className="col-auto">
            <div className="single-brand" style={{ maxWidth: "120px" }}>
              <img src={Brand1} alt="Brand 1" style={{ width: "100%" }} />
            </div>
          </div>
          <div className="col-auto">
            <div className="single-brand" style={{ maxWidth: "120px" }}>
              <img src={Brand2} alt="Brand 2" style={{ width: "100%" }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Brand;

